// extracted by mini-css-extract-plugin
export var readonly = "_j9-1";
export var star = "_j9-0";